import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import css from './StopMarkerPopup.module.css';
import {formatTime, getTs, gruntBossName} from "../../../utils";
import pokedex from "../../../utils/pokedex";
import Directions from "../Directions";
import Button from "@material-ui/core/Button";
import {submitGiovanni} from "../../../store/markerSlice";
import LinkDiscordButton from "../../Helper/Discord/LinkDiscordButton";

const lureType = {
	501: 'Regular',
	502: 'Glacial',
	503: 'Mossy',
	504: 'Magnetic',
};

const tmpStopIds = [];

const StopMarkerPopup = (props) => {
	const ts = getTs();

	navigator.clipboard && navigator.clipboard.writeText(props.stop.latitude + ", " + props.stop.longitude);

	console.log(props.stop.pokestop_id);
	tmpStopIds.push(props.stop.pokestop_id);
	console.log(tmpStopIds);
	// console.log(tmpStopIds.map(f => "'" + f + "'"));

	const onChangeBoss = (isGiovanni) => {
		props.submitGiovanni(props.stop.pokestop_id, !!isGiovanni);
	};

	let giovanni = null;
	if( props.stop.incident_grunt_type === 44 ) {
		if( props.stop.pokestop_id in props.giovanni ) {
			if( props.giovanni[props.stop.pokestop_id] )
				giovanni = <div>This was reported as an actual Giovanni!</div>;
			else
				giovanni = <div>This was reported as a decoy.</div>;
		} else if( props.discordUser ) {
			giovanni = <>
				<p>Eyes on the ground? What's here?</p>
				<div className={css.GruntButtons}>
					<Button size='small' variant='contained' onClick={() => onChangeBoss(false)}>Decoy</Button>
					<Button size='small' variant='contained' onClick={() => onChangeBoss(true)}>Giovanni</Button>
				</div>
			</>;
		} else {
			giovanni = <p>Is this Giovanni or a decoy? Log on to report! <LinkDiscordButton/></p>;
		}
	}

	return (<div className={css.StopMarkerPopup}>
		<div className={css.HeaderLine}>
			PokéStop: {props.stop.name}
		</div>

		{props.stop.expiration > ts &&
			<div>{lureType[props.stop.active_fort_modifier]} lure, active until {formatTime(props.stop.expiration, true)}</div>
		}

		{props.stop.incident_expiration > ts &&
		<div className={css.GruntLine}>
			{formatRocket(props.stop, props.giovanni[props.stop.pokestop_id])}
			{giovanni}
		</div>
		}

		{props.stop.quest &&
			<div className={css.QuestLine}>
				<div><span>Quest:</span> {props.stop.quest} for {formatReward(props.stop)}</div>
			</div>
		}

		<Directions id={props.id} latitude={props.stop.latitude} longitude={props.stop.longitude} />
	</div>);
};

const formatReward = (stop) => {
	if( stop.reward_encounter )
		return pokedex[stop['reward_encounter']]['name'] + ' Encounter';

	let num = stop.reward_item_num_min;
	if( num !== stop.reward_item_num_max )
		num += "-" + stop.reward_item_num_max;

	return num + " " + stop.reward_item_descr;
};

const formatRocket = (stop, giovanni) => {
	const boss = gruntBossName(stop.incident_grunt_type, giovanni);
	if( boss )
		return <div>Team Rocket leader ({boss}) until {formatTime(stop.incident_expiration, true)}.</div>
	else
		return <div>Team Rocket grunt until {formatTime(stop.incident_expiration, true)}.</div>
};

StopMarkerPopup.propTypes = {
	stop: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
	return {
		discordUser: state.core.discordUser,
		giovanni: state.marker.giovanni
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		submitGiovanni: (pokestop_id, incident_grunt_type) => dispatch(submitGiovanni(pokestop_id, incident_grunt_type))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(StopMarkerPopup);